export const AUTO_FINETUNE_ROUTE_NAMES = Object.freeze({
  ROOT: 'auto-finetune',
  LANDING: 'auto-finetune-landing',
  SUGGESTIONS: 'auto-finetune-suggestions',
  SUGGESTION_DETAIL: 'auto-finetune-suggestion-detail'
});

export const AUTO_FINETUNE_PATHS = Object.freeze({
  ROOT: '/auto-finetune',
  LANDING: '/auto-finetune/landing',
  SUGGESTIONS: '/auto-finetune/suggestions',
  SUGGESTION_DETAIL: '/auto-finetune/suggestions/detail'
});
